import { LoadPatientHideContact } from 'domain/usecases/patient/load-patient-hide-contact'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatientHideContact implements LoadPatientHideContact {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    params: LoadPatientHideContact.Params
  ): Promise<LoadPatientHideContact.Model> {
    return this.patientRepository.loadPatientHideContact(params)
  }
}
